/**
 * Область работы бота на клиенте-делегате (OnlineBotRunner).
 *
 * Клиент живого игрока исполняет ходы ботов тем же стором и той же цепочкой
 * middleware, что и действия самого игрока. Там, где действия игрока нужно
 * отличать от действий бота (блокировка ввода после нуля таймера хода —
 * utils/gameState/turn/turnInputLock: время игрока вышло, а бот на том же
 * одновременном этапе еще подтверждает свой бой), исполнитель выполняет шаг и
 * каждый диспатч бота внутри этой области.
 *
 * Метка — модульная, а не в самом экшене: экшен уходит на сервер и
 * ретранслируется остальным как есть, и пометка в нем выдала бы, кто из
 * игроков бот.
 */
let botWorkScopeDepth = 0;

export const runInBotWorkScope = (fn) => {
  botWorkScopeDepth += 1;
  try {
    return fn();
  } finally {
    botWorkScopeDepth -= 1;
  }
};

export const checkIfBotWorkScope = () => botWorkScopeDepth > 0;
